export default {
  bold: 'Pogrubiony',
  italic: 'Italski',
  underline: 'Podkreślać',
  list: 'Lista',
  link: 'Połączyć',
  codeblock: 'Blok kodu',
};
